import { formatCurrency, getCurrencySymbol } from '@angular/common'

export class GbBaseCurrency {
  /**
   * Cache for the Intl.NumberFormat instances
   * it would be better to use a LRU(Least Recently Used) cache to avoid unnecessary memory usage
   */
  private static formatterCache = new Map<string, Intl.NumberFormat>()

  /***
   * @deprecated we should use the formatValue method instead
   */
  public static getCurrencySymbol(
    value: number | string | null | undefined,
    currencyCode: string,
    locale: string,
    symbolFormat: 'wide' | 'narrow' = 'narrow',
  ): string | null {
    if (value || value === 0) {
      return formatCurrency(
        Number(value),
        locale,
        getCurrencySymbol(currencyCode, symbolFormat),
        currencyCode,
        +value % 1 === 0 ? '.0-0' : '.2-2',
      )
    }
    return null
  }

  public static getCurrencySymbolOnly(currencyCode: string = 'USD'): string {
    return getCurrencySymbol(currencyCode, 'narrow')
  }

  public static formatValue(value: number | string | null | undefined, currencyCode: string): string | null {
    if (value == null) return null

    const numericValue = typeof value === 'string' ? parseFloat(value) : value

    if (isNaN(numericValue)) return null

    const isInteger = numericValue % 1 === 0
    const minFracDigits = isInteger ? 0 : 2
    const maxFracDigits = isInteger ? 0 : 2

    const userLocale = navigator.language || 'en-US'

    // Create a cache key based on locale, currencyCode, and digits info
    const cacheKey = `${userLocale}-${currencyCode}-${minFracDigits}-${maxFracDigits}`

    // Check if a formatter already exists in the cache
    let formatter = this.formatterCache.get(cacheKey)
    if (!formatter) {
      // If no cached instance, create and store the new formatter
      formatter = new Intl.NumberFormat(userLocale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: minFracDigits,
        maximumFractionDigits: maxFracDigits,
      })
      this.formatterCache.set(cacheKey, formatter) // Cache it for future use
    }

    return formatter.format(numericValue)
  }
}
